import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { appReducers } from 'app/store/app.redusers';
import { NotifierEffects } from 'app/store/common-effects/notifier.effects';
import { AuthModule } from 'auth/auth.module';
import { GlobalErrorHandler } from 'core/error-handler/global-error-handler';
import { LocalProjectPreviewInterceptor } from 'core/interceptors/project/local-project-preview.interceptor';
import { BannedAccountInterceptor } from 'core/interceptors/token/banned-account.interceptor';
import { RefreshTokenInterceptor } from 'core/interceptors/token/refresh-token.interceptor';
import { CustomTranslateLoader } from 'core/services/custom-translate-loader';
import { LanguageService } from 'core/services/language.service';
import { environment } from 'environments/environment';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { SharedModule } from 'shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

const NgRx = [
  StoreModule.forRoot(appReducers),
  EffectsModule.forRoot([NotifierEffects]),
];

if (!environment.production) {
  NgRx.push(StoreDevtoolsModule.instrument({ connectInZone: true }));
}

const dbConfig: DBConfig = {
  name: 'DataBase',
  version: 1,
  objectStoresMeta: [
    {
      store: 'project-data',
      storeConfig: { autoIncrement: false, keyPath: 'type' },
      storeSchema: [
        { name: 'lastUpdate', keypath: '', options: { unique: false } },
        { name: 'appVersion', keypath: '', options: { unique: false } },
        { name: 'data', keypath: '', options: { unique: false } },
      ],
    },
  ],
};

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    AuthModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
      },
    }),
    NgxIndexedDBModule.forRoot(dbConfig),
    ...NgRx,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: BannedAccountInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    // TODO: Remove the local preview and its fixtures/tests once the backend supplies project data.
    ...(environment.hmr ? [{ provide: HTTP_INTERCEPTORS, useClass: LocalProjectPreviewInterceptor, multi: true }] : []),
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: (languageService: LanguageService) => languageService.currentLanguage,
      deps: [LanguageService],
    },
    LanguageService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ],
})
export class AppModule {

}
